import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import UploadIcon from '@mui/icons-material/Upload';
import { Button, Container, IconButton, SelectChangeEvent, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import * as DocumentHelper from '../../api/document/documentHelper';
import { route } from '../../route/Index';
import InputText from '../../shared/component/InputText';
import isAdmin from '../../shared/hoc/isAdmin';
import variable from '../../shared/style/variable';

interface IHelpDetailProps {}

const HelpContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
    margin-top: 2rem;
`;

const HelpDetail = (props: IHelpDetailProps) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const navigate = useNavigate();

    const { t } = useTranslation();

    const [file, setFile] = React.useState<any>();

    const handleClickSave = async () => {
        const formData = new FormData();
        formData.append('document', file);
        let res = await DocumentHelper.insertDocumentAsync(formData);
        if (res.status == 200) {
            Swal.fire({
                title: t('savedGeometry'),
                icon: 'success',
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const handleChangeFile = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        const file = event.target.files[0];
        setFile(file);
    };

    return (
        <>
            <Stack direction={'row'} padding={'0 1rem'} alignItems={'center'}>
                <ArrowForwardIosIcon style={{ fill: variable.greenLight }} />
                <Typography variant='h6' padding={'1rem 0'} color={variable.greenLight}>
                    {t('addNewDocument')}
                </Typography>
            </Stack>
            <HelpContainer maxWidth='md'>
                <Stack height={'100%'} direction='column'>
                    <Stack height={'85%'}>
                        <Stack direction={'row'} spacing={2} justifyContent={'center'}>
                            <InputText disabled customValue={file?.name ?? ''} />
                            <IconButton aria-label='add-file' onClick={() => fileInputRef.current!.click()}>
                                <UploadIcon />
                            </IconButton>
                            <input onChange={handleChangeFile} multiple={false} ref={fileInputRef} type='file' hidden />
                        </Stack>
                    </Stack>
                    <Stack alignItems='end'>
                        <Stack direction={'row'} spacing={2}>
                            <Button variant='white' onClick={() => navigate(route.backoffice)}>
                                {t('back')}
                            </Button>
                            <Button variant='orange' onClick={handleClickSave}>
                                {t('save')}
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            </HelpContainer>
        </>
    );
};

export default isAdmin(HelpDetail);
